import React, { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'
import useRequest from 'components/common/hooks/useRequest'
import Ret00cEditorPage from './Ret00cEditorPage'
import { getRet00cDetail, updateRet00c } from 'components/common/services/ret00cs'
import { getRet00cdTree } from 'components/common/services/ret00cds'
import { useRet00cGroupFilter } from './useRet00cGroupFilter'

function Edit(): JSX.Element {
  const navigate = useNavigate()
  const { id = '' } = useParams<{ id: string }>()
  const { reloadTree } = useRet00cGroupFilter()

  const { data: detailData } = useRequest(() => getRet00cDetail(id), {
    ready: !!id,
  })
  const { data: groupTreeData } = useRequest(() => getRet00cdTree())

  const record = useMemo(() => (detailData as any)?.data?.item || {}, [detailData])
  const ret00cas = useMemo(() => (detailData as any)?.data?.ret00cas || [], [detailData])
  const groupOptions = useMemo(() => (groupTreeData as any)?.data?.items || [], [groupTreeData])
  const currentRequestParams = useMemo(() => ret00cas.filter((item: any) => item.param_scope !== 'response'), [ret00cas])
  const currentResponseParams = useMemo(() => ret00cas.filter((item: any) => item.param_scope === 'response'), [ret00cas])

  return (
    <Ret00cEditorPage
      record={record}
      groupOptions={groupOptions}
      initialRequestItems={currentRequestParams}
      initialResponseItems={currentResponseParams}
      actionItems={[
        {
          key: 'back-detail',
          label: '返回详情',
          icon: <ArrowLeftOutlined />,
          onClick: () => { navigate(`/ret00cs/${id}`) },
        },
        {
          key: 'back-list',
          label: '返回列表',
          icon: <ArrowLeftOutlined />,
          onClick: () => { navigate('/ret00cs') },
        },
      ]}
      submitText='保存'
      successMessage='更新成功'
      failureMessage='更新失败'
      onSubmit={async (values, { requestParams, responseParams }) => {
        await updateRet00c(id, {
          ...values,
          request_params: requestParams,
          response_params: responseParams,
        })
        reloadTree()
        navigate(`/ret00cs/${id}`)
      }}
    />
  )
}

export default Edit
